<script setup>
import ModalDialog from './ModalDialog.vue'

defineProps({
  open: Boolean,
  title: { type: String, required: true },
  text: { type: String, required: true },
  confirmLabel: { type: String, default: 'Подтвердить' },
  tone: { type: String, default: 'danger' },
  pending: Boolean,
})
const emit = defineEmits(['close', 'confirm'])
</script>

<template>
  <ModalDialog :open="open" :title="title" eyebrow="Подтверждение" @close="!pending && emit('close')">
    <p class="confirm-copy">{{ text }}</p>
    <footer class="modal-actions">
      <button type="button" class="button button--ghost" :disabled="pending" @click="emit('close')">Не сейчас</button>
      <button type="button" class="button" :class="tone === 'danger' ? 'button--danger' : 'button--primary'" :disabled="pending" @click="emit('confirm')">
        <span v-if="pending" class="button-spinner" aria-hidden="true" />
        {{ pending ? 'Выполняем…' : confirmLabel }}
      </button>
    </footer>
  </ModalDialog>
</template>
